import _ from 'underscore';
import TrackerCollection from 'core/collections/tracker';
import MoodLog from 'mood/models/mood_log';
import DateNav from 'core/controllers/date_navigation';


export default TrackerCollection.extend({
  comparator: function (a, b) {
    // Sort by date, then id descending
    var a_date = DateNav.parse_date(a.get('date'));
    var b_date = DateNav.parse_date(b.get('date'));
    if (a_date > b_date) {
      return -1;
    } else if (a_date < b_date) {
      return 1;
    }
    return a.id > b.id ? -1 : 1;

  },
  model: MoodLog,
  urlRoot: MOOD_LOG_API_URL,

  average: function () {
    if (!this.length) {
      return null;
    }
    var ave = this.reduce(function (memo, mood) {
      return memo + mood.get('mood');
    }, 0) / this.length;
    return Math.round(ave);
  },
});

/* All mood logs by a user

  Mood is on a scale of 1-10. Ignore the source field, it isn't used at the moment.

  Example GET request:
    http://moodhacker.orcasdemo.com/api/tracker/v2/log/mood/?format=json&username=<username>&api_key=<api_key>&date__gte=2014-02-20&date__lte=2014-02-25

  Response:
  {
    "meta":{
      "limit":0,
      "offset":0,
      "total_count":9
    },
    "objects":[
      {
        "date":"2014-02-20",
        "id":9,
        "mood":3,
        "resource_uri":"/api/tracker/v2/log/mood/9/",
        "source":"B"
      },
      {
        "date":"2014-02-20",
        "id":8,
        "mood":4,
        "resource_uri":"/api/tracker/v2/log/mood/8/",
        "source":"B"
      },
      {
        "date":"2014-02-20",
        "id":7,
        "mood":5,
        "resource_uri":"/api/tracker/v2/log/mood/7/",
        "source":"B"
      },
      {
        "date":"2014-02-20",
        "id":6,
        "mood":8,
        "resource_uri":"/api/tracker/v2/log/mood/6/",
        "source":"B"
      },
      {
        "date":"2014-02-20",
        "id":5,
        "mood":9,
        "resource_uri":"/api/tracker/v2/log/mood/5/",
        "source":"B"
      },
      {
        "date":"2014-02-20",
        "id":4,
        "mood":7,
        "resource_uri":"/api/tracker/v2/log/mood/4/",
        "source":"B"
      },
      {
        "date":"2014-02-20",
        "id":3,
        "mood":3,
        "resource_uri":"/api/tracker/v2/log/mood/3/",
        "source":"B"
      },
      {
        "date":"2014-02-20",
        "id":2,
        "mood":2,
        "resource_uri":"/api/tracker/v2/log/mood/2/",
        "source":"B"
      },
      {
        "date":"2014-02-20",
        "id":1,
        "mood":1,
        "resource_uri":"/api/tracker/v2/log/mood/1/",
        "source":"B"
      }
    ]
  }

*/



//////////////////
// WEBPACK FOOTER
// ./node_modules/django-mood/mood/static/js/mood/collections/mood_log.js
// module id = 67
// module chunks = 0